/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.24",
    versionName: "0.2.0-nightly.2025.10.24",
    versionChannel: "nightly",
    buildDate: "2025-10-24T00:08:52.574Z",
    commitHash: "0f6e94ec4a6a01af3be1663ab5aa6003dc0d51b5",
};
